import React from 'react';

import { Descriptions, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { OnboardingInvitationSchema, OnboardingOrganizationSchema } from '@app/models/users';
import { formatDateAndTimeShort, fromUtc } from '@app/services/date';
import { formatContract } from '@app/services/formatContract';

interface IProps {
  invitation: OnboardingInvitationSchema;
}

export const InvitationCard: React.FC<IProps> = ({ invitation }) => {
  const pageT = useTranslation(NSKeys.counterpartyInvite);
  const commonT = useTranslation(NSKeys.common);

  const organization = (value: OnboardingOrganizationSchema) => (
    <span>
      {value.name}
      <Typography.Text type="secondary">
        {' '}
        · {commonT.t('inn')} {value.inn}
      </Typography.Text>
    </span>
  );

  return (
    <Descriptions
      bordered
      size="small"
      column={1}
      style={{ marginBottom: 24 }}
      items={[
        { key: 'client', label: pageT.t('card.client'), children: organization(invitation.client) },
        { key: 'counterparty', label: pageT.t('card.counterparty'), children: organization(invitation.counterparty) },
        { key: 'module', label: pageT.t('card.module'), children: commonT.t(`module.${invitation.module}` as const) },
        {
          key: 'contract',
          label: pageT.t('card.contract'),
          children: formatContract(invitation.contract_number, invitation.contract_date),
        },
        { key: 'email', label: pageT.t('card.email'), children: invitation.email },
        {
          key: 'expires',
          label: pageT.t('card.expiresAt'),
          children: formatDateAndTimeShort(fromUtc(invitation.expires_at)),
        },
      ]}
    />
  );
};
